import { Stack } from '@/ui';
import type { SxProps, Theme } from '@/ui/primitives';
import type { ReactNode } from 'react';

const cloneCellContainerSx = {
  width: '100%',
  minWidth: 0,
  height: '100%',
  justifyContent: 'flex-start',
  pb: '10px',
} as const;

export const CloneCellContainer = ({
  children,
  gap,
  pt = '8px',
}: {
  children: ReactNode;
  gap: 'none' | 'sm' | 'md';
  pt?: string;
}): JSX.Element => (
  <Stack gap={gap} align="flex-start" sx={[cloneCellContainerSx, { pt }] satisfies SxProps<Theme>}>
    {children}
  </Stack>
);
